import { authRef } from 'config'
import { action } from '../../dispatchAction'
import { USER_ACTION_TYPES } from '../types'

export const sendVerificationEmail = (
  successCallback: () => void = () => {
    return
  },
  errorCallback: (message: string) => void = () => {
    return
  }
) => async dispatch => {
  try {
    await authRef.currentUser?.sendEmailVerification()
    successCallback()
    dispatch(
      action(USER_ACTION_TYPES.send_verification_email, {
        isSendVerificationEmail: true
      })
    )
  } catch (e) {
    // dispatch the isSendVerification action here as well due to too many requests from same device error.
    if (e.code && e.code === 'auth/too-many-requests') {
      dispatch(
        action(USER_ACTION_TYPES.send_verification_email, {
          isSendVerificationEmail: true
        })
      )
    }
    errorCallback(e)
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions/sendVerificationEmail.action.ts